import styled from 'styled-components'

import { getResponsiveFontSizeCSS, applyIPadOnlyStyle } from 'helpers/css'

export const Content = styled.div`
    width: 45vw;
    min-height: 40vh;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
    @media only screen and (min-width: 993px) and (max-width: 1367px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
        min-height: 20vh;
    }
`

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const Heading = styled.div`
    font-size: ${getResponsiveFontSizeCSS(16, 20)};
    color: #e87d7c;
    font-weight: 800;
    ${applyIPadOnlyStyle('font-family: AvenirBold')}
`

export const Body = styled.div`
    font-size: ${getResponsiveFontSizeCSS(14, 16)};
    color: #333333;
    font-weight: 600;
    margin: 10px 0px;
    ${applyIPadOnlyStyle('font-family: AvenirBold')}
`

export const Footer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`

export const Button = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 30px;

    width: 77px;
    height: 34px;

    /* cta green */

    color: #fff;
    font-weight: 800;
    font-size: ${getResponsiveFontSizeCSS(12, 14)};
    background: #95c48c;
    border-radius: 4px;
`
